import { capitalizeFirstLetter } from 'commonComponents/FirstLetterCaptial'
import React from 'react'
import { Button } from 'reactstrap'
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import { Badge } from '@mui/material';
import { useSelector } from 'react-redux';

// Single Row Data Reperesent Component
function RowData({ itemInfo, handleEdit, handleDelete, handleView }) {
    
    return (
        <>
            <tbody>
                <tr className="align-items-center text-center" >
                    <td>{itemInfo?.serial_number}</td>
                    <td>{itemInfo?.first_name} {itemInfo?.last_name}</td>
                    <td>{itemInfo?.email_id || '-'} </td>

                    <td onClick={() => handleView(itemInfo?.uuid)} style={{cursor: 'pointer'}}>
                        {itemInfo?.company_name[0] || '-'}
                        {itemInfo?.company_name.length > 1 ? (
                            <>
                                <span className='circle ' >
                                   +{itemInfo?.company_name.length - 1}
                                </span>
                            </>
                        ) : ''}
                    </td>

                    <td>
                        {itemInfo?.role === 'company_admin' ? 'Company Admin' :
                            (itemInfo?.role === 'fluid_handler' ? 'Fluid Handler' :
                                (itemInfo?.role === 'super_admin' ? 'Super Admin' :
                                    (itemInfo?.role === 'enterprise_admin' ? 'Enterprise Admin' : null)))}
                    </td>


                    <td className={itemInfo?.status === 'active' ? 'text-success' : 'text-danger'}>
                        {
                            itemInfo?.status === 'active' ? <Chip label={capitalizeFirstLetter(itemInfo?.status)} color="success" sx={{ p: 1 }} /> : <Chip label={capitalizeFirstLetter(itemInfo?.status)} color="error" />
                        }
                    </td>

                    <td style={{ padding: '0px' }}>
                        <div className='d-flex d-flex justify-content-around ' >
                            <i className="fa-solid fa-eye icon_hover" onClick={() => handleView(itemInfo?.uuid)}></i>
                            <i className="fa-solid fa-pen icon_hover" onClick={() => handleEdit(itemInfo?.uuid)}></i>
                            <i className="fa-solid fa-trash icon_hover" onClick={() => handleDelete(itemInfo?.uuid)}></i>
                        </div>
                    </td>
                </tr>
            </tbody>
        </>
    )
}

export default RowData
